import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../providers/AuthProvider";

export function RequireVerifiedBusiness() {
  const { business, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  if (user.role === "super_admin") return <Outlet />;

  if (!business || business.status !== "verified") {
    return <Navigate to="/pending-verification" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

